// extracted by mini-css-extract-plugin
export var colored = "bureau-module--colored--JIDmv";
export var navLink = "bureau-module--nav-link--LVA0d";
export var scroll = "bureau-module--scroll--2LP2n";